import EcoTextTc, { EcoTextTcItemProps } from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { tcLang } from './lang';
import getLocal from '@/app/utils/getLocal';

export default function Comp({ pageType }: { pageType?: 'ac' | 'ultra' }) {
    const { locale } = getLocal();
    const tcLanguage = tcLang[locale] || tcLang['eu'];

    let items: EcoTextTcItemProps[] = [
        {
            isHead: true,
            title: tcLanguage.head1,
        },
        {
            title: tcLanguage.titleA2,
            desc: tcLanguage.descA2,
            isOpen: true,
        },
        {
            title: tcLanguage.titleA3,
            desc: tcLanguage.descA3,
        },
    ];

    if (pageType === 'ultra') {
        items = [
            {
                isHead: true,
                title: tcLanguage.ultra?.head1,
            },
            {
                title: tcLanguage.ultra?.titleA1,
                // desc: tcLanguage.descA1,
                isOpen: true,
            },
        ];
    }

    if (pageType === 'ac') {
        items = [
            {
                isHead: true,
                title: tcLanguage.ac?.head1,
            },
            {
                title: tcLanguage.ac?.titleA1,
                // desc: tcLanguage.descA1,
                isOpen: true,
            },
        ];
    }

    if (locale === 'us') {
        items = [
            {
                isHead: true,
                title: tcLanguage?.head1,
            },
            {
                title: tcLanguage?.titleA1,
                // desc: tcLanguage.descA1,
                isOpen: true,
            },
        ];
    }

    return <EcoTextTc items={items} className={styles.comp} />;
}
